import React, { useState } from 'react';
import DownloadButton from './DownloadButton';
import * as api from '../../../../../../../../services/apis';
import {
  downloadPdf,
  downloadPDFInvoice,
} from '../../../../../../../../helpers/invoiceHelpers';
import { useKeycloak } from '../../../../../../../../hooks/useKeycloak';
import { OvalSpinner } from '../../../../../../../../components/shared/OvalSpinner';

const DownloadButtonContainer = ({ rowData, ...restProps }) => {
  const [loading, setLoading] = useState(false);
  const { userInfo, realm } = useKeycloak();
  const handleDownload = () => {
    if (userInfo) {
      const uuid = rowData.uniqueReferenceIdentifier;
      setLoading(true);
      downloadPdf(uuid);
      setLoading(false);
    }
  };

  return loading ? (
    <OvalSpinner width={40} height={40} color="#26890d" />
  ) : (
    <DownloadButton {...restProps} onDownload={handleDownload} />
  );
};

export default React.memo(DownloadButtonContainer);
